<template>
    <div v-if="lang" class="estate-data">
        <div class="container">
            <div class="row">
                <div class="col-auto">
                    <div class="estate-price">
                        <span class="current-price" v-html="estate.price"></span>
                        <span v-if="estate.price_alternative" class="current-price-euro" v-html="estate.price_alternative"></span>
                        <estate-discount :estate="estate" />
                    </div>

                    <estate-card-data :estate="estate" />
                </div>
                
                <template v-if="! $root.is_mobile">
                    <div class="col-auto">
                        <h1 class="estate-title">
                            {{ estate.title }}
                        </h1>

                        <h2 class="estate-subtitle">
                            {{ estate.subtitle }}
                        </h2>
                    </div>
                </template>

                <div class="col-auto col-lg-auto estate-actions" >
                    <div v-if="backLink" class="back-link">
                        <masked-image src="/img/icons/arrow-back-list.svg"></masked-image>
                        <a :href="backLink" class="back"><span>{{ lang.labels.back }}</span></a>
                    </div>
        
                    <template v-if="! $root.is_mobile">
                        <!--<a
                            :href="(estate.ad_type == 'construction') ? '/pdf-cantiere/' + estate.id : '/pdf-immobili/' + estate.id"
                            target="_blank">
                            <img src="/img/icons/pdf-file.svg" alt="Stampa pdf" class="print-pdf">
                        </a>-->
                        
                        <estate-actions :estate="estate" />
                    </template>

                    <div class="share-button">
                        <estate-share
                            :estate="estate"
                            :estate-id="estate.id"
                            :agency-id="estate.agency ? estate.agency.id : null"
                            :type="estate.ad_type"
                            >
                        </estate-share>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardData from './CardData'
import Discount from './Discount'
import Share from './Share'
import UserActions from './UserActions'
import VueCookies from 'vue-cookies'

export default {
    components: {
        'estate-actions': UserActions,
        'estate-card-data': CardData,
        'estate-discount': Discount,
        'estate-share': Share,
    },

    props: {
        backLink: {
            type: String,
            required: false,
        },

        estate: {
            type: Object,
            required: true,
        },

        lang: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {

        }
    },

    created() {
        if (this.estate.ad_type == 'estate' && window.trackLibrary) {
            setTimeout(() =>
                window.trackLibrary.track('events.impressioneImmobile', {
                    immobile_id: this.estate.id,
                    agenzia_id: this.estate.agency.id,
                    tipoPagina : 'scheda',
                    nazione: this.estate.country,
                    origine: (window.location.search.substr(1).split('&').indexOf('origine=newsletter') !== -1) ? 'newsletter' : 'portale'
                })
            , 100)
        }

        // --- Gestione cookie
        var recent = JSON.parse($cookies.get('recent_' + this.estate.ad_type))
        if (recent) {
            recent.unshift(this.estate.id)
        } else {
            recent = [this.estate.id]
        }

        var recent_add = recent.filter(function(item, pos) {
            return recent.indexOf(item) == pos
        })
        
        $cookies.set('recent_' + this.estate.ad_type, JSON.stringify(recent_add.slice(0, 10)), '1y', '', '', true)
    }

}
</script>